import _ from 'lodash';
import axios, { Cancel, CancelToken } from 'axios';
import { store } from '../reducers';
import NotificationCenter, {
  NotificationName,
} from '../libs/NotificationCenter';
import { OMS_API_TOKEN } from '../configs/env';

class whttp {
  constructor() {
    const { auth: { authorization } = {} } = store.getState();

    this.authorization = authorization;

    this.storeStateDidUpdate = this.storeStateDidUpdate.bind(this);

    // 註冊store update的通知
    store.subscribe(this.storeStateDidUpdate);
  }

  storeStateDidUpdate() {
    const { auth: { app_id, authorization, user_id } = {} } = store.getState();
    this.app_id = app_id;

    this.authorization = authorization;

    this.user_id = user_id;
  }

  setCookie(key, val, exp) {
    if (exp) {
      document.cookie = key + '=' + val + ';expires=' + exp + ';path=/';
    } else {
      document.cookie = key + '=' + val + ';path=/';
    }
  }

  getCookie(key) {
    let name = key + '=';

    let ca = document.cookie.split(';');

    for (var i = 0; i < ca.length; i++) {
      var c = ca[i].trim();
      if (c.indexOf(name) === 0) return c.substring(name.length, c.length);
    }

    return null;
  }

  getToken() {
    return this.authorization;
  }

  getHeaders() {
    const headers = {};
    if (!_.isEmpty(this.getToken())) {
      headers.Authorization = this.getToken();
    }
    return headers;
  }

  // send 'get|post|delete' http request
  // return cancelToken
  send(method, url, params, data, callback, isOms) {
    // 封裝callback，排除外部發生error造成axios的catch
    let cb = (state, res) => {
      if (!callback) return;
      try {
        callback(state, res);
      } catch (err) {
        console.error('whttp callback error', err);
      }
    };

    let cancelToken;

    axios({
      method: method,
      timeout: 600000,
      headers: isOms ? { Authorization: OMS_API_TOKEN } : this.getHeaders(),
      withCredentials: false,
      url: url,
      params: params,
      data: data,
      cancelToken: new CancelToken((token) => {
        cancelToken = token;
      }),
    })
      .then((response) => {
        let state = true;

        if (response.status !== 200) {
          state = false;
        }

        const { code = 200, reason = '未知錯誤', data = {} } = response.data;

        let res = { code: code, reason: reason, data: data };

        this._handle_error_code(code);

        cb(state, res);
      })
      .catch((error) => {
        this._handle_error_code(_.get(error, 'response.status'));

        let res = {
          code: _.get(error, 'response.status', 400),
          reason: _.get(error, 'response.statusText', '發生錯誤'),
          error: error,
          data: {},
        };
        const data = _.get(error, 'response.data');
        if (data) {
          res.code = data.code;
          res.reason = data.reason;
        }

        cb(false, res);
      });

    return cancelToken;
  }

  get(url, query, callback) {
    return this.send('get', url, query, null, callback, false);
  }
  post(url, data, callback) {
    return this.send('post', url, null, data, callback, false);
  }
  delete(url, query, callback) {
    return this.send('delete', url, query, null, callback, false);
  }

  //呼叫apigeeApi
  getApigeeApi(url, query, callback) {
    return this.send('get', url, query, null, callback, true);
  }
  postApigeeApi(url, data, callback) {
    return this.send('post', url, null, data, callback, true);
  }

  // 共用Request，只執行最後一道，但是callback都會被call到
  // 減少消耗
  requestInfos = [];
  sharedGet(url, query, callback) {
    const requestName = url.replace(/(\.)/g, '__');
    //console.log('sharedGet url:', url)
    let requestInfo = _.get(this.requestInfos, requestName);
    let cancelToken = _.get(requestInfo, `cancelToken`);
    if (cancelToken) {
      cancelToken(`sharedGet ${requestName} By Last Query`);
    }

    if (!requestInfo) {
      requestInfo = {
        name: requestName,
        cancelToken: null,
        callbacks: [],
      };
      this.requestInfos[requestName] = requestInfo;
    }

    requestInfo.callbacks.push(callback);
    const callbackWapper = (state, res) => {
      if (res.error instanceof Cancel) return;

      const callbacks = _.get(
        this.requestInfos,
        `${requestName}.callbacks`,
        []
      );

      _.forEach(callbacks, (callback) => callback(state, res));

      delete this.requestInfos[requestName];
    };
    requestInfo.cancelToken = this.send(
      'get',
      url,
      query,
      null,
      callbackWapper
    );
  }

  _handle_error_code(code) {
    code = parseInt(code, 10);

    if (code === 401) {
      this._handle_auth_denied();
    }
  }

  // 未登入
  // access token 過期
  _handle_auth_denied = _.debounce(() => {
    NotificationCenter.default.post(NotificationName.AuthDenied);
  }, 100);
}

export default new whttp();



// WEBPACK FOOTER //
// ./src/libs/whttp.js